"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var styles_1 = require("@mui/material/styles");
var ModalCloseButton_1 = __importDefault(require("./ModalCloseButton"));
var StyledDialog = (0, styles_1.styled)(Dialog_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        ' .MuiPaper-root:first': {
            borderRadius: 4,
            padding: 0,
            overflowY: 'visible',
        },
        ' .MuiBackdrop-root': { background: 'rgba(0, 0, 0, 0.5)' },
        ' .MuiPaper-rounded': { borderRadius: theme.spacing(1.5) },
    });
});
var Modal = function (_a) {
    var open = _a.open, onClose = _a.onClose, label = _a.label, children = _a.children, maxWidth = _a.maxWidth, hideCloseButton = _a.hideCloseButton, rest = __rest(_a, ["open", "onClose", "label", "children", "maxWidth", "hideCloseButton"]);
    var stopPropagation = function (cb) { return function (e) {
        e.stopPropagation();
        cb === null || cb === void 0 ? void 0 : cb(e);
    }; };
    return ((0, jsx_runtime_1.jsxs)(StyledDialog, __assign({}, rest, { open: !!open, onClose: onClose, PaperProps: __assign(__assign({}, rest.PaperProps), { onClick: stopPropagation(rest.onClick) }), onBackdropClick: stopPropagation(rest.onBackdropClick), "aria-labelledby": label, maxWidth: maxWidth, fullWidth: true }, { children: [children, onClose && !hideCloseButton && (0, jsx_runtime_1.jsx)(ModalCloseButton_1.default, { onClick: onClose })] })));
};
exports.default = Modal;
